var map = {
	"./arrows-horizontal.svg": 215,
	"./font/iconfont.svg": 360,
	"./logo-fw-simple.svg": 361,
	"./logo-fw.png.svg": 216,
	"./logo-fw.svg": 28,
	"./logo-yimian.svg": 362,
	"./logo.svg": 363,
	"./logos/oneview.svg": 364,
	"./logos/wechat.svg": 217,
	"./logos/yidrone.svg": 365,
	"./logos/yimian.svg": 218,
	"./success.svg": 366,
	"./warning.svg": 367
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 401;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = 401
// module chunks = 1